class Config {
    api = "";
    dashboard = "";
    environment = process.env.REACT_APP_ENV;
    version = process.env.REACT_APP_VERSION;
    segmentKey = "";
    devUserEmail = "";
    devUserPassword = "";

    constructor() {
        switch(process.env.REACT_APP_ENV){
            case "develop":
                this.api = process.env.REACT_APP_API_DEV;
                this.dashboard = process.env.REACT_APP_DASHBOARD_DEV;
                this.segmentKey = process.env.REACT_APP_SEGMENT_KEY_DEV;
                this.devUserEmail = process.env.REACT_APP_DEV_EMAIL;
                this.devUserPassword = process.env.REACT_APP_DEV_PASSWORD;
                break;
            case "stage":
                this.api = process.env.REACT_APP_API_STAGE;
                this.dashboard = process.env.REACT_APP_DASHBOARD_STAGE;
                this.segmentKey = process.env.REACT_APP_SEGMENT_KEY_DEV;
                break;
            case "production":
                this.api = process.env.REACT_APP_API_PROD;
                this.dashboard = process.env.REACT_APP_DASHBOARD_PROD;
                this.segmentKey = process.env.REACT_APP_SEGMENT_KEY_PROD;
                break;
            default:
                throw new Error("Invalid REACT_APP_ENV");
        }
    }
}

// The timeout of the converting listing GET, the first read of a store_version 1 project, which converts it inside the request. It has to end
// before nginx or Cloudflare cut the request off, or the editor never sees its own timeout. 55 s until O2 is read, then min(nginx fastcgi_read_timeout, 100) - 5 s.
export const CONVERTING_GET_TIMEOUT_MS = 55000;

//export new frozen singleton instance - first import will initialise, imports after will refer to same instance
export default Object.freeze(new Config());